import { Grid } from "@mui/material";
import { MAX_SELECT_BRANDS } from "contexts/NewCampaign";
import { forwardRef } from "react";
import { BentoBrand } from "schemas/dashboard";

import SkeletonBrand from "features/Home/Sidebar/FavoritesList/SkeletonBrand";

import SelectedBrand from "./SelectedBrand";

const REF_OFFSET = 9;

interface IProps {
  displayedBrands: BentoBrand[];
  loading: boolean;
  handleSelect: (bentoBrand: BentoBrand) => void;
  selectedBrandIds: Set<number>;
  selectAll: boolean;
}

const BrandList = forwardRef(
  (
    {
      displayedBrands,
      loading,
      handleSelect,
      selectedBrandIds,
      selectAll,
    }: IProps,
    ref,
  ) => {
    return (
      <Grid container>
        {displayedBrands.map((bentoBrand: BentoBrand, index: number) => (
          <SelectedBrand
            key={bentoBrand.id}
            ref={
              (
                REF_OFFSET > displayedBrands.length
                  ? displayedBrands.length - 1 === index
                  : displayedBrands.length - REF_OFFSET === index
              )
                ? ref
                : null
            }
            bentoBrand={bentoBrand}
            handleSelect={handleSelect}
            isSelected={
              selectedBrandIds.has(bentoBrand.id) ||
              (selectAll && index < MAX_SELECT_BRANDS)
            }
          />
        ))}
        {loading && (
          <>
            <SkeletonBrand />
            <SkeletonBrand />
            <SkeletonBrand />
          </>
        )}
      </Grid>
    );
  },
);

export default BrandList;
